<template>
  <div>
    <header class="cart-header">
      Betting Slip
      <QBtn
        icon="delete"
        dense
        flat
        round
        @click="cartStore.$reset()"
      />
    </header>
    <CartItems
      v-slot="scope"
      class="cart-items"
    >
      <slot
        name="item"
        v-bind="scope"
      />
    </CartItems>
    <CartForm @submit="$emit('submit')" />
  </div>
</template>
<script setup>
import '@/css/cart.css'
import { useCartStore } from '@/stores/cart.js'
import CartForm from './CartForm.vue'
import CartItems from './CartItems.vue'

defineEmits(['submit'])

defineProps({
  cartItem:{
    type:Object,
    default:null,
  }
})

const cartStore = useCartStore()
</script>
